import Reveal from "@/components/Reveal";
import { CheckCircle2 } from "lucide-react";

const POINTS = [
  {
    title: "Informazione gratuita sui tuoi diritti",
    text: "Ti spieghiamo in parole semplici cosa dice la legge sul sovraindebitamento e quali tutele hai, senza costi e senza gergo tecnico.",
  },
  {
    title: "Accompagnamento passo dopo passo",
    text: "Dalla prima consulenza alla verifica dei documenti: camminiamo al tuo fianco finché la situazione non è risolta.",
  },
  {
    title: "Supporto psicologico nei casi di maggiore necessità",
    text: "Il peso del debito non è solo economico. Grazie alla collaborazione della Dott.ssa V. Graffeo, psicologa professionista, offriamo ascolto gratuito a chi ne ha più bisogno.",
  },
];

export default function Mission() {
  return (
    <section id="missione" data-testid="mission-section" className="container-site py-20 lg:py-28">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
        <Reveal>
          <span className="eyebrow">La nostra missione</span>
          <h2 className="mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight text-brand-ink leading-tight">
            Nessuno dovrebbe affrontare i debiti{" "}
            <span className="text-brand-aqua">da solo e senza informazioni.</span>
          </h2>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">
            L'Associazione Vittime del Debito nasce per dare voce e strumenti a chi si sente
            schiacciato dai debiti. Non chiediamo nulla in cambio: il nostro lavoro è reso
            possibile dal volontariato e dal sistema dell'8 per mille, che ci permette di aiutare
            sempre più persone.
          </p>
          <blockquote className="mt-8 border-l-4 border-brand-blue pl-6 text-xl font-semibold text-brand-ink italic">
            "La tua rinascita è un diritto, non un privilegio."
          </blockquote>
          <div className="mt-8 rounded-3xl overflow-hidden border-4 border-white shadow-xl shadow-brand-blue/10" data-testid="mission-image">
            <img
              src="https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=1200&q=80"
              alt="Una famiglia serena mano nella mano al tramonto"
              loading="lazy"
              className="w-full h-64 object-cover"
            />
          </div>
        </Reveal>

        <div className="space-y-5">
          {POINTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.12}>
              <div className="flex gap-4 rounded-2xl border border-slate-100 bg-white p-6 shadow-sm hover:shadow-lg hover:shadow-brand-blue/5 hover:-translate-y-1 transition-[box-shadow,transform] duration-300" data-testid={`mission-point-${i}`}>
                <CheckCircle2 className="w-7 h-7 text-brand-aqua shrink-0 mt-0.5" />
                <div>
                  <h3 className="font-bold text-lg text-brand-ink">{p.title}</h3>
                  <p className="mt-1 text-slate-600 leading-relaxed">{p.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
